import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=70da841d&scoped=true&"
import script from "./ImagePreview.vue?vue&type=script&lang=js&"
export * from "./ImagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da841d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70da841d')) {
      api.createRecord('70da841d', component.options)
    } else {
      api.reload('70da841d', component.options)
    }
    module.hot.accept("./ImagePreview.vue?vue&type=template&id=70da841d&scoped=true&", function () {
      api.rerender('70da841d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/IntelligentBooking/components/ImagePreview.vue"
export default component.exports